<template>
  <div>
    <div>
      <el-button
        style="margin-bottom: 10px"
        type="primary"
        icon="el-icon-plus"
        @click="openEditWhiteListEntryDialog(true, {})"
        >新增白名单项</el-button
      >
    </div>
    <div>
      <el-form
        ref="form"
        :model="form"
        label-position="left"
        label-width="85px"
        size="mini"
        style="margin-top: 30px"
      >
        <el-form-item label="查询方式：">
          <el-radio-group v-model="form.queryType">
            <el-radio :label="1">全量</el-radio>
            <el-radio :label="2">UID</el-radio>
            <el-radio :label="3">AID</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          :label="
            form.queryType == 1
              ? '全量：'
              : form.queryType == 2
              ? 'UID：'
              : 'AID：'
          "
        >
          <el-input
            v-if="form.queryType == 2"
            v-model="form.uid"
            clearable
            style="width: 170px"
          ></el-input>

          <el-input
            v-if="form.queryType == 3"
            v-model="form.aid"
            clearable
            style="width: 170px"
          ></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onClickQueryBtn()"
            style="margin-left: 10px"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="list"
      border
      size="small"
      style="width: 1111px"
      height="650px"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="list.length == 0"
    >
      <el-table-column prop="uid" label="UID" align="center" width="80">
        <template slot-scope="scope">
          <span>
            <a
              style="text-decoration: none"
              href="javascript:;"
              @click="toRouterPlayerInfoPage('uid', scope.row.uid)"
            >
              {{ scope.row.uid ? scope.row.uid : "" }}</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column prop="aid" label="AID" align="center" width="80">
        <template slot-scope="scope">
          <span
            ><a
              style="text-decoration: none"
              href="javascript:;"
              @click="toRouterPlayerInfoPage('aid', scope.row.aid)"
              >{{ scope.row.aid ? scope.row.aid : "" }}</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column prop="key" label="道具" align="center" width="350">
        <template slot-scope="scope">
          <span>{{ scope.row.key ? getItemDesc(scope.row.key) : "全部" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="remark"
        label="备注"
        show-overflow-tooltip
        align="center"
        width="300"
      >
      </el-table-column>
      <el-table-column
        prop="deadline"
        label="到期时间"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.deadline != "0"
              ? ms2ymdhm(Number(scope.row.deadline))
              : ""
          }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            @click="removeWhiteListEntry(scope.row.id, scope.row)"
            >删除</el-button
          >
          <el-button
            type="primary"
            round
            size="mini"
            @click="openEditWhiteListEntryDialog(false, scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
  
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

export default {
  data() {
    return {
      list: [], // 白名单列表里展示的数据
      form: {
        queryType: 1, // 查询方式（1-全量查询 2-uid查询 3-aid查询)
        uid: "",
        aid: "",
      },
      currentCondition: 1,
      availableItems: [],
    };
  },

  async created() {
    await this.loadAvailableItems();
    await this.loadWhiteList(0, 10);
  },

  methods: {
    loadMore() {
      this.loadWhiteList(this.list.length, 10);
    },
    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    /**
     * 查询集合
     */
    async loadWhiteList(skip, limit) {
      if (skip == 0) {
        this.list = [];
      }

      let condition = "";
      let value = 0;
      switch (this.currentCondition) {
        case 1: {
          condition = "all";
          break;
        }
        case 2: {
          condition = "uid";
          value = this.form.uid;
          break;
        }
        case 3: {
          condition = "aid";
          value = this.form.aid;
          break;
        }
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getPlayerDataAuditEntriesByCondition`,
          {
            skip: skip,
            limit: limit,
            condition: condition,
            value: value,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.list = this.list.concat(listInResponse);
    },
    /**
     * 点击查询按钮
     */
    async onClickQueryBtn() {
      this.currentCondition = this.form.queryType;
      await this.loadWhiteList(0, 20);
    },

    /**
     * 查询可用道具集合
     */
    async loadAvailableItems() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAppendixList`,
          {
            isShowPayItem: true,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      if (resData.data.categories.length > 0) {
        for (let category of resData.data.categories) {
          this.availableItems.push({
            label: category.name,
            value: category.name,
            children: (() => {
              let result = [];
              for (let e of category.entries) {
                result.push({
                  label: e.name,
                  value: e.id,
                });
              }
              return result;
            })(),
          });
        }
      }
    },

    /**
     *  获取道具ID对应的道具类别和名称
     */
    getItemDesc(itemID) {
      let result = "未知";
      for (let category of this.availableItems) {
        for (let entry of category.children) {
          if (entry.value == itemID) {
            result = category.label + "/" + entry.label;
          }
        }
      }

      return result;
    },
    /**
     * 删除白名单
     */
    async removeWhiteListEntry(id, entry) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除玩家${
            entry.uid == 0 ? "AID: " + entry.aid : "UID: " + entry.uid
          }的白名单？`
        );

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/delPlayerDataAuditEntry`,
            {
              id: id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id == id) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    /**
     * 跳转到玩家详情界面
     * @param {*}
     */
    toRouterPlayerInfoPage(condition, value) {
      let query = {};
      switch (condition) {
        case "uid": {
          query = { uid: value, tab: "playerList" };
          break;
        }
        case "aid": {
          query = { aid: value, tab: "playerList" };
          break;
        }
      }

      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: query,
        }).href,
        "_blank"
      );
    },
    /**
     *  打开“添加/修改白名单”对话框
     */
    openEditWhiteListEntryDialog(isCreate, oldData) {
      let byType = "uid";
      if (isCreate == false) {
        byType = oldData.aid != 0 ? "aid" : byType;
      }

      dialogutil.open("EditWhiteListDialog", {
        closedCallback: () => {
          this.loadWhiteList(0, 20);
        },
        data: { isCreate: isCreate, form: oldData, byType },
      });
    },
  },
};
</script>